import { Navigate, Outlet } from "react-router-dom";

const isAuthenticated = (): boolean => {
  const doctorId = localStorage.getItem("doctorId");
  const doctorRole = localStorage.getItem("doctorRole");
  return !!doctorId && doctorRole === "DOCTOR";
};

export const ProtectedRoute = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/" replace />;
};
